import { Option } from '@joor/design-system'
import { FormikProps } from 'formik'

/**
 * Returns utility functions for state synchronization between formik and
 * the Design System's Dropdown component.
 * @param fieldId id of the form field corresponding to the Dropdown
 * @param formik related formik object
 * @returns the utility functions
 */
export const getDropdownCallbacks = <Values extends Record<string, unknown>>(
  fieldId: keyof Values & string,
  formik: FormikProps<Values>,
  clearable = true,
) => ({
  onSelect: ({ selected }: { selected: Option }) => {
    formik.setFieldValue(fieldId, selected)
  },
  ...(clearable && {
    onClear: (): void => {
      formik.setFieldValue(fieldId, '')
    },
  }),
})

export type DropdownCallbacks = ReturnType<typeof getDropdownCallbacks>
